export default __webpack_public_path__ + "static/media/video_placeholder.45b54463.jpeg";